module.exports = __webpack_public_path__ + "static/media/card-box.b7694a58.svg";